import styled from 'styled-components';
import { FC } from 'react';
import { media } from 'src/styles/designs';
import { AboutUs_Videos } from 'src/graphql/schema.graphql';
import { ThumbnailSwiper } from 'src/components/common/Swipers/ThumbnailSwiper';
import { SwiperSlide } from 'swiper/react';
import { Thumbnail } from 'src/modules/materials/components/Thumbnail';

const Container = styled.div`
  margin-top: 20px;

  ${media.w.greaterThanOrEqual.desktop} {
    margin-top: 60px;
    margin-right: calc(-1 * var(--constraint-container-right-inner-margin));
    margin-left: calc(-1 * var(--constraint-container-left-inner-margin));
  }
`;

interface AboutUsVideosProps {
  videos?: AboutUs_Videos[];
}

export const AboutUsVideos: FC<AboutUsVideosProps> = ({ videos }) => {
  if (!videos || videos.length === 0) {
    return null;
  }

  return (
    <Container>
      <ThumbnailSwiper>
        {videos.map((v) => (
          <SwiperSlide key={v.id} tag="li">
            <Thumbnail item={v.videos_id} />
          </SwiperSlide>
        ))}
      </ThumbnailSwiper>
    </Container>
  );
};
